import { render } from "./ProfileThemeThreeOld.vue?vue&type=template&id=525326a8"
import script from "./ProfileThemeThreeOld.vue?vue&type=script&lang=js"
export * from "./ProfileThemeThreeOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/themes/legacy_themes/ProfileThemeThreeOld.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "525326a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('525326a8', __exports__)) {
    api.reload('525326a8', __exports__)
  }
  
  module.hot.accept("./ProfileThemeThreeOld.vue?vue&type=template&id=525326a8", () => {
    api.rerender('525326a8', render)
  })

}


export default __exports__